import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'custom_interrogations_list_page' */ './CustomInterrogationListPage'
  ),
);
